// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["dated", "next", "prev"]
  connect() {
    liveSearch()
  }

  next(e) {
    e.preventDefault()
    this.datedTarget.value = this.nextTarget.dataset.date
    this.refresh()
  }

  prev(e) {
    e.preventDefault()
    this.datedTarget.value = this.prevTarget.dataset.date
    this.refresh()
  }

  refresh(date) {
    //
    // This catches the user changing the date by the Next/Prev buttons
    // Update both colums and the control date form 
    //
    document.querySelector("#control_date").closest('form').dispatchEvent(new Event('change'))
  }
}
